import { ReportGeneratorTemplate } from './report-generator-template';

export class EntityForReportGenerator {
  entityId: number;
  entityName: string;
  isSelected?: boolean;
  entityCountryName?: string;
  domicileIsoCode?: string;
  selectedTemplateId?: string;
  templates?: ReportGeneratorTemplate;
}
